// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"179":"f49ab01a","427":"8f8787fb","594":"3e218e45"}[chunkId] + ".js";
};